import apiReq from 'core/api';

export interface LlmUsageStatsTotal {
  documents_processed: number;
  action_count: number;
  tokens_in_total: number;
  tokens_out_total: number;
  /** Среднее время ответа ИИ, мс */
  response_time_avg: number;
}

/** GET /llm/usage/stats-total */
export const getLlmUsageStatsTotal = (): Promise<LlmUsageStatsTotal | undefined> =>
  apiReq<LlmUsageStatsTotal>('llm/usage/stats-total');

export interface LlmUsageStatItem {
  date: string; // YYYY-MM-DD
  action_count: number;
  tokens_in_total: number;
  tokens_out_total: number;
  response_time_avg: number; // ms
}

export interface LlmUsageStatByScenario {
  scenario_id: string;
  scenario_title: string;
  action_count: number;
  tokens_in_total: number;
  tokens_out_total: number;
  response_time_avg: number; // ms
}

export interface LlmStatsFilters {
  project_id?: string;
  user_id?: string;
  date_from?: string; // YYYY-MM-DD
  date_to?: string; // YYYY-MM-DD
  scenario_id?: string;
}

function buildQueryString(filters?: LlmStatsFilters): string {
  if (!filters) return '';
  const params = (Object.entries(filters) as [string, string | undefined][])
    .filter((entry): entry is [string, string] => entry[1] !== undefined)
    .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
  return params.length > 0 ? `?${params.join('&')}` : '';
}

/** GET /llm/usage/stats?project_id=&user_id=&date_from=&date_to=&scenario_id= */
export const getLlmUsageStats = (
  filters?: LlmStatsFilters
): Promise<LlmUsageStatItem[] | undefined> =>
  apiReq<LlmUsageStatItem[]>(`llm/usage/stats${buildQueryString(filters)}`);

/** GET /llm/usage/stats-by-scenario?project_id=&user_id=&date_from=&date_to= */
export const getLlmUsageStatsByScenario = (
  filters?: Omit<LlmStatsFilters, 'scenario_id'>
): Promise<LlmUsageStatByScenario[] | undefined> =>
  apiReq<LlmUsageStatByScenario[]>(
    `llm/usage/stats-by-scenario${buildQueryString(filters as LlmStatsFilters)}`
  );
